import Tabs from "#common/tabs/Tabs"
import PERMISOS from "#constants/perfiles"
import { TERMINATION } from "#constants/StatusRequest "
import useHasPermission from "#hooks/useHasPermission"
import { Box, Stack } from "@mui/material"
import Accounting from "Components/bajas/pages/Accounting"
import Perceptions from "Components/bajas/pages/Perceptions"
import { useCallback } from "react"
import { useSelector } from "react-redux"
import ApprovalRH from "./ApprovalRH"
import DebtBajas from "./DebtBajas"
import { DialogBajaProvider } from "./DialogBajaContext"
import Documents from "./Documents"
import InfoBajasDialog, {
	InformationSolicitudBajas,
	InformationTracsaSolicitudBajas,
} from "./InfoBajasDialog"

export default function DetailTermination({
	baja,
	dialogIndex,
	setDialogIndex,
	disabled = false,
	reload = () => {},
	setButtonsDialog = () => {},
	closeDialog = () => {},
}) {
	const { hasPermissionV2 } = useHasPermission()
	const isRH = hasPermissionV2(PERMISOS.RH_ALL)
	const isJefeNominas = hasPermissionV2(PERMISOS.JEFE_NOMINAS)
	const tabsChange = useCallback(() => {
		setButtonsDialog(null)
	}, [setButtonsDialog])
	const statusId = baja?.termination_status_id
	const tabsShow = !TERMINATION.All_FINISH.includes(baja?.termination_status_id)
	const isFinish = !tabsShow
	// (baja?.termination_status_id !== TERMINATION.FINALIZADA ||
	// 	baja?.termination_status_id !== TERMINATION.RECHAZADA) &&
	// baja?.termination_status_id !== TERMINATION.SOLICITADA

	const request_collaborator_id = useSelector((state) => state.user.colaborador.id)
	const tabs = [
		{
			title: "Solicitud",
			component: (
				<div style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
					<InformationSolicitudBajas baja={baja} />
				</div>
			),
			show:
				isRH || isJefeNominas || baja.request_collaborator === request_collaborator_id,
		},
	]
	if (statusId !== TERMINATION.SOLICITADA) {
		tabs.push(
			{
				title: "Tracsa",
				component: (
					<div style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
						<InformationTracsaSolicitudBajas baja={baja} />
					</div>
				),
				show: isRH,
			},
			{
				title: "Adeudos",
				component: <DebtBajas />,
				show: tabsShow,
			},
			{
				title: "Percepciones y deducciones",

				component: <Perceptions />,
				show: tabsShow,
			},
			{
				title: "Contabilidad",

				component: <Accounting />,
				// show: tabsShow,
				show: (isRH || isJefeNominas) && isFinish,
			},

			{
				title: "Documentos",
				component: (
					<div style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
						<Documents />
					</div>
				),
				show: isRH || baja.request_collaborator === request_collaborator_id,
			},
		)
	}

	return (
		<Box width={"100%"}>
			<DialogBajaProvider
				baja={baja}
				reload={reload}
				isRH={isRH}
				setButtonsDialog={setButtonsDialog}
				closeDialog={closeDialog}
				disabled={disabled}
			>
				<Stack container spacing={2} rowSpacing={3}>
					<div style={{ paddingLeft: "3rem", paddingRight: "1rem" }}>
						<InfoBajasDialog baja={baja} notAll={!isRH} />
					</div>
					<Tabs
						tabs={tabs}
						onChange={tabsChange}
						value={dialogIndex}
						setValue={setDialogIndex}
					/>
					<ApprovalRH baja={baja} hidden={!isRH} />
				</Stack>
			</DialogBajaProvider>
		</Box>
	)
}
